<mat-card>
  <mat-card-header>
    <mat-card-title>{{ data.details?.cameraDetail?.name }}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <sn-image-player
      class="sn-image-player image-player-img"
      [src]="data.thumbnailUrl"
      [autoplay]="true"
      [aspectRatio]="aspectRatio"
      [refreshTime]="0"
    >
      <sn-player-footer-section alignment="end" fsPlayerFooter>
        <sn-icon-button
          *ngIf="data.source.playbackUrls"
          (click)="setViewClip(data.item, data)"
          [matTooltip]="'View Clip'"
          ><sn-icon>videocam</sn-icon></sn-icon-button
        >
      </sn-player-footer-section>
    </sn-image-player>
  </mat-card-content>
  <mat-card-footer>
    <sn-icon-button
      [matMenuTriggerFor]="menu"
      (click)="$event.stopPropagation()"
      class="actionsMenu"
    >
      <sn-icon>more_vert</sn-icon>
    </sn-icon-button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item *ngIf="data.source.playbackUrls" (click)="setViewClip()">
        View Clip
      </button>
    </mat-menu>
  </mat-card-footer>
</mat-card>
